<div class="modal-content">
    <div class="modal-header">
        <h2 class="modal-title pull-left" id="my-modal-title">{{'APPEAL_FACT_REQUESTED_TITLE' | globalTranslate}}</h2>
        <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
            <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
        </button>
    </div>
    <div class="modal-body">        
        <p [innerHTML]="'APPEAL_FACT_REQUESTED_DESC' | globalTranslate"></p>
    </div>    
    <div class="modal-footer" [ngClass]="{'lang-sp':translatedLang === 'sp', 'action-container':translatedLang !== 'sp'}">
        <div class="me-2 ml-2" >
          <button type="button" id="dialog1" class="btn d-grid btn-secondary" [ngClass]="{'lang-sp': translatedLang === 'sp'}" (click)="uploadProof()">{{
            'UPLOAD_APPEAL_FACT_BTN' | globalTranslate }}</button>
        </div>
        <div class="me-2 ml-2" >
          <button type="button" id="dialog1" class="btn d-grid btn-link" [ngClass]="{'lang-sp': translatedLang === 'sp'}" (click)="appealFactForm()">{{ 'APPEAL_FACT_FORM_BTN' | globalTranslate
            }}</button>
        </div>
      </div>
</div>
